import { Box, Flex, Text } from '@chakra-ui/react';
import { Grid } from '@time-line/components/common';
import { Mitopure } from '@time-line/components/icons';
import {
  MixedContentContainer,
  RichTextResolver,
} from 'components/common/RichTextResolver';
import { Chart } from 'components/sections/MitopureElaboration/Chart';
import { Multiplier } from 'components/sections/MitopureElaboration/Multiplier';
import { useInView } from 'react-intersection-observer';
import type { MitopureSolution as MitopureSolutionProps } from 'types/cms/blocks/MitopureSolution';

export function MitopureSolution({
  title,
  description,
  showMitopureLogo = true,
}: MitopureSolutionProps) {
  const { ref, inView } = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  return (
    <Flex
      className="section--mitopure-solution"
      flexDir="column"
      pb={{ base: 'lg', lg: '3xl' }}
      my="2xl"
      justifyContent="space-between"
    >
      <Grid pb="3xl" gridRowGap="sm" position="relative" zIndex={1}>
        <Grid.Inner>
          <Multiplier
            display={{ base: 'block', lg: 'none' }}
            gridColumn="span 7"
            width="100%"
            height="auto"
            color="red.300"
          />
          <Box gridColumn={{ base: 'span 12', lg: 'span 6' }}>
            <Text as="h2" size="h2" whiteSpace="pre-wrap">
              {showMitopureLogo && (
                <>
                  <Mitopure
                    color="red.300"
                    width={{ base: '100px', lg: '135px' }}
                    height="auto"
                  />{' '}
                </>
              )}
              {title}
            </Text>
          </Box>
          <Box gridColumn={{ base: 'span 12', lg: '8/-1' }}>
            <RichTextResolver
              blocks={description}
              container={MixedContentContainer}
            />
          </Box>
        </Grid.Inner>
      </Grid>
      <Grid pb={{ base: 'lg', lg: 0 }} position="relative" zIndex={1}>
        <Grid.Inner gridColumnGap={{ lg: 'lg' }} gridRowGap="sm">
          <Multiplier
            display={{ base: 'none', lg: 'block' }}
            gridColumn="span 4"
            width="100%"
            height="auto"
            color="red.300"
            position="relative"
            top="1.65%"
          />
          <Flex
            gridColumn={{ base: 'span 12', lg: 'span 8' }}
            color="white"
            position="relative"
            flexDir="column"
            justifyContent="flex-end"
          >
            <Chart
              colorScheme="red"
              isScrolled={inView}
              intersectionRef={ref}
            />
          </Flex>
        </Grid.Inner>
      </Grid>
    </Flex>
  );
}
